<template>
  <div class="scroll-vertical dashboard-container">
    <tiles v-for="(row,i) in rows" :key="i">
      <div v-for="obj in row" :key="obj.id" class="tile is-parent is-4">
        <tile-deployment :deployment="obj" :title="obj.name" :deleteFunc="deleteFunc">
        </tile-deployment>
      </div>
    </tiles>
  </div>
</template>

<script>
import _ from 'lodash';
import mixin from '@/mixins/deployments';
import Tiles from '@/components/Tiles.vue';
import TileDeployment from '@/components/deployments/tiles/TileDeployment.vue';

export default {
  name: 'DeploymentsTiles',
  mixins: [mixin],
  components: { Tiles, TileDeployment },
  props: {
    deployments: {
      type: Array,
      required: true,
    },
    deleteFunc: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns: 3,
    };
  },
  computed: {
    rows() {
      return _.chunk(this.deployments, this.columns);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
